import React, { useState,useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { setYearList,setMonthList,setDateRange,formatDate } from './Function';
import { useAcdemicDepartmentList } from './DynamicUse';
import { Row,Col,Card,Table,Button,Placeholder,Form,Spinner,InputGroup } from 'react-bootstrap';
const RekhiArchive = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const DepartmentList = useAcdemicDepartmentList();
    const[isLoading, setLoading] = useState(true);
    const[isLoadMore, setLoadMore] = useState(true);
    const[Rows, setRows] = useState(0);
    const[Events,setEvents]=useState([]);
    const[Department, setDepartment] = useState(Number(localStorage.getItem('setDepartment')) || 0);
    const[keyword, setKeyword] = useState('');
    const[year, setYear] = useState(0);
    const[month, setMonth] = useState(0);
    const DepartmentChange = (e) => {
        localStorage.removeItem('setDepartment');
        setDepartment(Number(e.target.value) || 0);
    };
    const KeywordChange = (e) => setKeyword(e.target.value.trim() || '');
    const YearChange = (e) => setYear(Number(e.target.value) || 0);
    const MonthChange = (e) => setMonth(Number(e.target.value) || 0);
    useEffect(()=>
    {
        
        fetchEvents(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    const fetchEvents = async (isReset) => 
    {
        if (isReset === true) 
        {
            setRows(0);  // Reset Rows if this is a new search
            setEvents([]);  // Clear previous results
        }
        try 
        {
            setLoading(true);
            var scId = 0;
            const keywordText = keyword || 'none';
            const { startDate, endDate } = setDateRange(year, month, 0, 1, 0);
            const currentRows = isReset ? 0 : Rows;
            const callApi = global.config.API_URL + `events/rekhilist/${Department}/${scId}/${keywordText}/${startDate}/${endDate}/${currentRows}`;
            if(global.config.IsPrint) console.info('EventsList : API', callApi);
            const response = await fetch(callApi);
            const result = await response.json();
            if (result.length > 0) 
            {
                setEvents(prevResults => Rows === 0 ? result : [...prevResults, ...result]);
                setRows(currentRows + 30);             
                setLoadMore(true);
            } 
            else 
            {
                setLoadMore(false);
            }
            
        } catch (error) 
        {
            console.error('fetchEvents : Error', error.message);
        } 
        finally 
        {
            setLoading(false);
        }
    };
    const handleSubmit = (e) => 
    {
        e.preventDefault();
        if (Department === 0 && !keyword && year === 0 && month === 0) 
        {
            alert(t('FilterAlert'));
            return;
        }
        fetchEvents(true);
    };
    return (
        <Card className=' mb-4'>
            <Card.Header className='text-center fs-3 text-uppercase'>{t('Events')}</Card.Header>
            <Card.Body>
                <Card className=' mb-3'>
                    <Card.Body>
                        <form onSubmit={handleSubmit}>
                        <div className='mb-2 fw-bold'>{t('FilterSearch')}</div>
                        <Row className='g-2'>
                            <Col md={3} data-aos="fade-right" data-aos-duration="1000">
                                <Form.Select onChange={DepartmentChange} value={Department}>
                                    <option value={0}>{t('Department')}</option>
                                    {DepartmentList.map((sd,index) => (
                                    <option key={index} value={sd.sd_id}>
                                        {appLanguage === 'hi' ? sd.sd_name_hi || sd.sd_name : sd.sd_name}
                                    </option>
                                    ))}
                                </Form.Select>
                            </Col>
                            <Col md={3} data-aos="fade-right" data-aos-duration="1000">
                                <Form.Control type="text" placeholder={t('FilterPlaceholder')} onChange={KeywordChange} value={keyword} />
                            </Col>
                            <Col md={6} data-aos="fade-left" data-aos-duration="1000">
                                <InputGroup>
                                    <Form.Select onChange={YearChange} value={year}>
                                        <option value={0}>{t('FilterYear')}</option>
                                        {setYearList(0, 1).map((year) => (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <Form.Select onChange={MonthChange} value={month}>
                                        <option value={0}>{t('FilterMonth')}</option>
                                        {setMonthList().map(({ value, label }) => (
                                            <option key={value} value={value}>
                                                {label}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <Button className='btn btn-info' type='submit'><i className="bi bi-search"></i> {t('FilterSearch')}</Button>
                                </InputGroup>
                            </Col>
                        </Row>
                        </form>
                    </Card.Body>
                </Card>
                <Table responsive bordered className='rounded-top text-center overflow-hidden mb-0'>
                    <thead>
                    <tr>
                        <th className='w-50'>{t('Title')}</th>
                        <th>{t('Department')}</th>
                        <th>{t('Duration')}</th>
                        <th>{t('Download')}</th>
                    </tr>
                    </thead>
                    {isLoading ? (
                        <tbody>
                        {[...Array(10)].map((_,index)=>(
                        <tr key={index}>
                            <th className="table-success"><Placeholder xs={10} /></th>
                            <td className="text-center"><Placeholder xs={10} /></td>
                            <td className="text-center"><Placeholder xs={10} /></td>
                            <td className="text-center"><Button className="btn btn-light w-75"><Placeholder xs={12} /></Button></td>                            
                        </tr>
                        ))}
                        </tbody>
                    ) : (
                        <tbody>
                        {Events.map((se,index)=>(
                        <tr key={index}>
                            <th className="table-success" dangerouslySetInnerHTML={{ __html: appLanguage === 'hi' ? (se.se_display_en === "1" ? se.se_name_hi || '' : se.se_name_hi || se.se_name) : se.se_name }}></th>
                            <td className="text-center">{(appLanguage === 'hi' && se.departments.sd_name_hi) ? se.departments.sd_name_hi : se.departments.sd_name}</td>
                            <td className="text-center">{formatDate(se.se_start_duration)} TO {formatDate(se.se_end_duration)}</td>
                            <td className="text-center">
                                <NavLink to={appLanguage ==='hi' ? `/घटनाक्रम/विवरण/${se.se_htaccess_hi || se.se_htaccess}` : `/event/details/${se.se_htaccess}`} className="btn btn-light" target='_blank' rel="noopener noreferrer">
                                    {t('ViewDownload')}
                                </NavLink>
                            </td>
                        </tr>
                        ))}
                        </tbody>
                    )}
                </Table>
                {isLoadMore &&
                <div className='text-center p-3'>
                    <Button className='btn btn-info mt-3' onClick={() => fetchEvents(false)} disabled={isLoading}>
                        {isLoading ? (
                        <React.Fragment>
                            <Spinner animation="grow" variant="light" size="sm" />
                            <Spinner animation="grow" variant="danger" size="sm" />
                            <span className='ms-2'>{t('PleaseWait')}</span>
                        </React.Fragment>
                        ) : t('LoadMore')}
                    </Button>
                </div>}
            </Card.Body>
        </Card>
    );
}
export default RekhiArchive;